import { Component } from '@angular/core';
import { CaptureHistoryItemTypeUpdatedComponent } from '../capture-history-item-type-updated/capture-history-item-type-updated.component';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';


@Component({
    selector: 'app-capture-history-item-type-unreversed',
    templateUrl: './capture-history-item-type-unreversed.component.html',
    imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent]
})
export class CaptureHistoryItemTypeUnreversedComponent extends CaptureHistoryItemTypeUpdatedComponent {
  get description() {
    const parts = [`Capture unreversed to ${this.displayStatus}`];

    const statusReasons = this.mapStatusReasons();
    if (statusReasons.length > 0) {
      parts.push(statusReasons.join(', '));
    }

    return parts.join(': ');
  }

  get verifiedDuringNoReferralPeriod() {
    return this.captureHistoryItem.data.verifiedDuringNoReferralPeriod;
  }
}
